import { Menu } from './menu.model';
import { menuItems } from './menu';
import { menuCatalogo } from './menu'; 
import { menuCaja } from './menu'; 
import { menuFacturacion } from './menu'; 
import { menuInventarios } from './menu';
import { menuContabilidad } from './menu'; 
import { menuInico } from './menu'; 


export class MenuService {

    constructor() {}

    public getMenuItems(): Array<Menu> {
        return menuItems;
    }
    public getMenuCatalogo(): Array<Menu> {
        return menuCatalogo;
    }
    public getMenuCaja(): Array<Menu> {
        return menuCaja;
    }
    public getMenuFacturacion(): Array<Menu> {
        return menuFacturacion;
    }
    public getMenuInventarios(): Array<Menu> {
        return menuInventarios;
    }
    public getContabilidad(): Array<Menu> {
        return menuContabilidad;
    }
    public getInico(): Array<Menu> {
        return menuInico;
    }
    
}


// WEBPACK FOOTER //
// ./src/app/layout/sidenav/menu/menu.service.ts